import { Checkbox } from "antd";
import { useTranslation } from "react-i18next";
import AlertIcon from "../../icons/AlertIcon";
import SorterDoubleArrow from "../../icons/SorterDoubleArrow";
import SorterUpArrow from "../../icons/SorterUpArrow";
import SorterDownArrow from "../../icons/SorterDownArrow ";
import ItemRow from "./ItemRow";
import s from "./styles";

function getSortingArrow(sorting, c) {
  let columnArrow = null;
  if (c.sortable) {
    columnArrow = <SorterDoubleArrow color="#fff" />;
    if (c.columnId === sorting.columnId) {
      if (sorting.order === 1) {
        columnArrow = <SorterUpArrow color="#fff" />;
      } else if (sorting.order === -1) {
        columnArrow = <SorterDownArrow color="#fff" />;
      }
    }
  }
  return columnArrow;
}

function ListWithMoreOptions({
  data,
  columns = [],
  tableStyle,
  sorting,
  changeSorting,
  handleDeleteWorker,
  handleEdit,
  handleShowDetails,
  showDetails,
  width,
  moreOption,
  checkboxOption,
  selected,
  setSelected,
  deleteOption,
}) {
  const { t } = useTranslation();

  return (
    <s.Container>
      <s.TableContainer widthProp={width} style={tableStyle}>
        {columns.map((c, i) => {
          const columnArrow = getSortingArrow(sorting, c);
          return (
            <s.TableCell
              key={i}
              onClick={() =>
                c.sortable &&
                changeSorting(
                  c.columnId,
                  sorting.columnId === c.columnId ? -sorting.order : 1
                )
              }
              style={{
                fontWeight: "500",
                fontSize: "15px",
              }}
            >
              <s.InsideCell>
                <s.divInsideCell>
                  {i === 0 && checkboxOption && (
                    <Checkbox
                      style={{ marginRight: "15px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (e.target.checked) {
                          setSelected(data.map((item) => item.id));
                        } else {
                          setSelected([]);
                        }
                      }}
                      checked={selected.length === data.length}
                      defaultChecked={false}
                    />
                  )}
                  {c.title}
                </s.divInsideCell>
                {columnArrow}
              </s.InsideCell>
            </s.TableCell>
          );
        })}
        {data &&
          data.map((item, i) => (
            <ItemRow
              key={`row${item.id}-${i}`}
              keyId={item.id}
              item={item}
              columns={item.columns}
              rowRenderer={item.rowRenderer}
              line={i !== data.length - 1}
              grid={tableStyle.gridTemplateColumns}
              handleDeleteItem={() => handleDeleteWorker(item)}
              handleEditItem={handleEdit}
              handleShowDetails={() => handleShowDetails(item)}
              showDetails={showDetails}
              moreOption={moreOption}
              deleteOption={deleteOption}
            />
          ))}
      </s.TableContainer>
      {(!data || data.length === 0) && (
        <s.NoItemsContainer>
          <s.NoItemsMessageCenter>
            <AlertIcon style={{ display: "block", marginBottom: "7px" }} />
            {t("general.noData")}
          </s.NoItemsMessageCenter>
        </s.NoItemsContainer>
      )}
    </s.Container>
  );
}

export default ListWithMoreOptions;
